const Primitive: React.FC<{
  text: string;
  children: React.ReactNode;
  up?: boolean;
}> = ({ text, children, up }) => {
  return (
    <span className="relative group">
      <span className="underline decoration-dotted cursor-help">{text}</span>
      <div
        className={`absolute left-full w-96 drop-shadow-lg hidden group-hover:flex z-10 ${
          up ? "bottom-0 items-end" : "top-0 items-start"
        }`}
      >
        <div className="h-0 border-r-8 border-y-8 border-oso-light-blue border-y-transparent"></div>
        <div className="-my-2 p-4 rounded-lg bg-oso-light-blue grow">
          {children}
        </div>
      </div>
    </span>
  );
};

export const RolePrimitive: React.FC<{
  up?: boolean;
}> = ({ up }) => (
  <Primitive text="role" up={up}>
    <div className="text-lg font-bold">Authorization Fundamentals: Roles</div>A{" "}
    <span className="font-bold">role</span> is a connection between a user and a
    resource. A user{"'"}s role determines what actions they can perform on the
    resource. Examples of typical roles include {`"admin"`}, {`"editor"`}, and{" "}
    {`"viewer"`}.
  </Primitive>
);

export const RelationPrimitive: React.FC<{
  up?: boolean;
}> = ({ up }) => (
  <Primitive text="relation" up={up}>
    <div className="text-lg font-bold">
      Authorization Fundamentals: Relations
    </div>
    A <span className="font-bold">relation</span> is a connection between two
    resources where a user{"'"}s access to one resource informs their access to
    the other. For example, a file is related to its containing folder.
  </Primitive>
);

export const AttributePrimitive: React.FC<{
  up?: boolean;
}> = ({ up }) => (
  <Primitive text="attribute" up={up}>
    <div className="text-lg font-bold">
      Authorization Fundamentals: Attributes
    </div>
    An <span className="font-bold">attribute</span> is a property of a resource
    that affects how users may access it. For example, an attribute may indicate
    that a resource is public, allowing all users to access it.
  </Primitive>
);
